import {
    TextField,
    Slider,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect, useState, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import Breadcrumb from '../../common/Breadcrumb';
import {
    CHALLENGE_TYPE_OBJECT,
    CHALLENGE_PRIVACY,
    CHALLENGE_THEME,
    PICTURE_VARIANTS,
} from '../../common/constants';
import DropdownFormInput from '../../common/DropdownFormInput';
import FormInput from '../../common/FormInput';
import RadioInputWithDescription from '../../common/RadioInputWithDescription';
import ThemeInputSelector from '../../common/ThemeSelectorInput';
import DatePicker from '../../common/DatePicker';
import './styles.scss';
import Picture from '../../common/Picture';
import LoaderGif from './../../icons/LoaderGif.gif';
import Search from './../../icons/icons-search.svg';
import TrashIcon from './../../icons/trash-alt.svg';
import TargetIcon from './../../icons/target.svg';
import BrowseIcon from './../../icons/browse.svg';
import PointerMarker from './../../icons/pointer.svg';
import AutoCompleteSingle from '../../common/AutoCompleteSingle';
import { connect } from 'react-redux';
import challengePropTypes from '../../common/ChallengeRow/propTypes';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import {
    Marker,
    GoogleMap,
    Circle,
    StandaloneSearchBox,
} from '@react-google-maps/api';
import { MAP_STYLE_LIGHT } from '../../map/Map/constants';
import { noop } from '../../common/propTypes';
import {
    clearCreatedChallengeState,
    createChallengeRequested,
    featuredChallengeRequested,
} from './redux/actions';
import { getUser, getUserPermissionsKeys } from '../../screens/auth/selectors';
import { allowSubmission, transformChallengeForAPI } from './transformers';
import { useHistory } from 'react-router-dom';
import {
    ROUTE_CHALLENGES,
    ROUTE_CHALLENGE_CREATE,
} from '../../navigation/constants';
import {
    getCreateChallengeError,
    getCreatedChallenge,
    creatingChallengeState,
    getFeaturedChallenges,
} from './redux/selectors';
import isUrl from 'is-url';

function numFormatter(num) {
    return (num / 1000).toFixed(1) + ' KM(s)';
}

const PrettoSlider = withStyles({
    root: {
        color: '#52af77',
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -4,
        marginLeft: -12,
        boxShadow: 'inherit',
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        top: 29,
        left: -44,
        background: '#010b19',
        borderRadius: 17,
        padding: '0px 18px',
        height: 29,
        '& *': {
            background: 'transparent',
            color: '#fff',
            width: 'max-content',
            marginTop: -1,
        },
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    disabled: {
        opacity: 0.25,
    },
    rail: {
        height: 8,
        borderRadius: 4,
        backgroundColor: '#f2f2f2',
    },
    mark: {
        backgroundColor: '#027aff',
    },
    markActive: {
        backgroundColor: '#027aff',
    },
})(Slider);

const CreateChallenge = ({
    challenges,
    onCreate,
    createdChallenge,
    clearCreatedChallenge,
    user,
    parentChallenges,
    creatingChallenge,
    createError,
    permissions,
}) => {
    const breadcrumNavigation = [
        { title: 'Challenges', path: '/challenges' },
        { title: 'Create a Challenge', path: '#' },
    ];
    const defaultParams = {
        isPrivate: 'private',
        backgroundColor: Object.keys(CHALLENGE_THEME)[0],
    };
    const history = useHistory();
    const [challengeType, setChallengeType] = useState('local');
    const [challengeParams, setChallengeParams] = useState({
        ...defaultParams,
    });
    const [selectedPlace, setSelectedPlace] = useState([]);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [worldwide, setWorldwide] = useState(false);
    const [radius, setRadius] = useState(10);
    const [parentChallenge, setParentChallenge] = useState(null);
    const [refSearchBox, setRefSearchBox] = useState(null);
    const [challengeModal, setChallengeModal] = useState(false);
    const [error, setError] = useState(null);
    const [allowSubmit, setAllowSubmit] = useState(false);
    const [parentLoading, setParentLoading] = useState(false);
    const [tempImage, setTempImage] = useState(null);
    const [imgError, setImgError] = useState(null);

    let timer = setTimeout(() => {
        console.log();
    }, 1000);

    useEffect(() => {
        parentChallenges();
    }, []);

    useEffect(() => {
        setParentLoading(false);
    }, [challenges]);

    useEffect(() => {
        setError(createError);
    }, [createError]);

    useEffect(() => {
        setAllowSubmit(
            allowSubmission({
                ...challengeParams,
                challengeType,
                circleRadius: radius,
                location: ifPlaces.location,
                locality: ifPlaces.locality,
                worldwide,
            }).submit,
        );
    }, [challengeParams, selectedPlace, worldwide, radius]);

    const setInput = (key, value) => {
        setChallengeParams({ ...challengeParams, [key]: value });
    };

    const challengeModalOpen = () => {
        setChallengeModal(true);
    };

    const challengeModalClose = () => {
        setChallengeModal(false);
    };

    useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError(null);
            }, 2000);
        }
    }, [error]);

    useEffect(() => {
        if (createdChallenge && createdChallenge.id) {
            clearCreatedChallenge();
            history.push(`/challenges/${createdChallenge.id}`, {
                from: ROUTE_CHALLENGE_CREATE,
                challenge: createdChallenge,
            });
        }
    }, [createdChallenge]);

    function clickUploadBanner() {
        setImgError(null);
        document.getElementById('upload_banner').click();
    }

    const challengeSpecificField = () => {
        switch (challengeType) {
            case CHALLENGE_TYPE_OBJECT.GLOBAL.id:
                return (
                    <>
                        <div className="row mb-3">
                            <div className="col">
                                <button
                                    className={`btn btn-block btn-upload upload-banner ${
                                        challengeParams.banner
                                            ? 'change-image'
                                            : ''
                                    } position-relative`}
                                    onClick={() => clickUploadBanner()}
                                >
                                    {uploadingImage ? (
                                        <img
                                            src={LoaderGif}
                                            width={'25px'}
                                            height={'25px'}
                                        />
                                    ) : tempImage ? (
                                        <>
                                            <div className="position-absolute image-avatar">
                                                <Picture
                                                    source={tempImage}
                                                    variant={
                                                        PICTURE_VARIANTS.VARIANT_SMALL_CREATE_CHALLENGE
                                                    }
                                                />
                                            </div>
                                            Change Image
                                        </>
                                    ) : (
                                        <>
                                            <span className="icon-latest-gallery upload-banner-icon"></span>
                                            Upload Challenge Image*
                                        </>
                                    )}
                                </button>
                                <div
                                    className="m-0 description"
                                    style={{
                                        fontSize: 12,
                                        marginTop: 5,
                                        display: 'flex',
                                        fontFamily: 'Proxima Nova Bld',
                                        justifyContent: 'start',
                                    }}
                                >
                                    Recommended image size is 1242 x 720px.
                                </div>
                                {imgError && (
                                    <div
                                        className="m-0 description"
                                        style={{
                                            fontSize: 12,
                                            marginTop: 5,
                                            display: 'flex',
                                            fontFamily: 'Proxima Nova Bld',
                                            justifyContent: 'start',
                                            color: 'red',
                                        }}
                                    >
                                        The image you are using is too large.
                                        Please reduce size to less than 3MB and
                                        try again.
                                    </div>
                                )}
                                <input
                                    type="file"
                                    id={'upload_banner'}
                                    onChange={(e) => {
                                        if (
                                            !(e.target.files[0].size <= 3145728)
                                        ) {
                                            setImgError(true);
                                        }
                                        if (
                                            e.target.files[0].size <= 3145728 &&
                                            e.target.files[0].type.match(
                                                'image*',
                                            )
                                        ) {
                                            setUploadingImage(true);
                                            setInput('banner', e.target.files);
                                            setTempImage(
                                                URL.createObjectURL(
                                                    e.target.files[0],
                                                ),
                                            );
                                            setUploadingImage(false);
                                        }
                                    }}
                                    hidden={true}
                                    accept="image/png, image/jpeg"
                                ></input>
                            </div>
                        </div>
                    </>
                );
            case CHALLENGE_TYPE_OBJECT.CONNECTED.id:
                return (
                    <>
                        <AutoCompleteSingle
                            id="research-country-autocomplete"
                            title="Select Challenge*"
                            onInputChange={(event, value) => {
                                clearTimeout(timer);
                                timer = setTimeout(() => {
                                    setParentLoading(true);
                                    parentChallenges(value);
                                }, 700);
                            }}
                            isLoading={parentLoading}
                            hasIcon={false}
                            bootstrapIcon="icon-flag"
                            options={challenges}
                            onSelect={(challenge) => {
                                setParentChallenge(challenge);
                                setInput('parentChallengeId', challenge);
                            }}
                            placeholder={'Select Challenge'}
                            disabled={false}
                            getOptionLabel={(option) =>
                                `${option.title || option.name}`
                            }
                            renderOption={(option) =>
                                option.title || option.name
                            }
                            value={parentChallenge}
                        />
                    </>
                );
            default:
                return null;
        }
    };

    const showChallengeForm = () => (
        <>
            {challengeSpecificField()}

            <RadioInputWithDescription
                title="Privacy*"
                options={Object.values(CHALLENGE_PRIVACY)}
                selected={challengeParams.isPrivate || null}
                onSelect={(val) => setInput('isPrivate', val)}
            />
            <FormInput
                title="Title*"
                bootstrapIcon="icon-latest-pencil"
                bottomtext="max 50 characters"
            >
                <TextField
                    value={challengeParams.name || ''}
                    placeholder={'Enter Challenge Title'}
                    onChange={(event) => setInput('name', event.target.value)}
                    inputProps={{ maxLength: 50 }}
                />
            </FormInput>
            <FormInput title={'Details*'} bootstrapIcon="icon-latest-pencil">
                <TextField
                    value={challengeParams.mission || ''}
                    type={'text'}
                    placeholder={'Write a small detail about your challenge'}
                    onChange={(event) =>
                        setInput('mission', event.target.value)
                    }
                    multiline
                    rows={4}
                />
            </FormInput>
            <FormInput
                title={'Website'}
                bootstrapIcon={BrowseIcon}
                stylesIcon={{ justifyContent: 'center' }}
                bottomtext="Website link should be under 500 characters"
            >
                <TextField
                    value={challengeParams.website || ''}
                    type={'text'}
                    placeholder={
                        'Enter your website like: https://litterati.org'
                    }
                    inputProps={{ maxLength: 500 }}
                    onChange={(event) =>
                        setInput('website', event.target.value)
                    }
                />
            </FormInput>
            <FormInput
                title="Litter Goal*"
                bootstrapIcon={TrashIcon}
                stylesIcon={{ justifyContent: 'center' }}
                bottomtext="Enter a number between 10 and 1000000000"
            >
                <TextField
                    // value={'abcd'}
                    value={challengeParams.litterQuantityTarget || ''}
                    type="text"
                    placeholder={'Enter # of Pieces'}
                    inputProps={{ maxLength: 10 }}
                    onChange={(event) => {
                        if (
                            /^[1-9]\d*$/.test(event.target.value) ||
                            event.target.value == ''
                        ) {
                            let goal = event.target.value.substr(0, 10);
                            setInput('litterQuantityTarget', goal);
                        }
                    }}
                />
            </FormInput>
            <FormInput
                title="PARTICIPANT GOAL"
                bootstrapIcon={TargetIcon}
                stylesIcon={{ justifyContent: 'center' }}
                bottomtext="Enter a number between 1 and 1,000,000"
            >
                <TextField
                    // value={'abcd'}
                    value={challengeParams.memberTarget || ''}
                    type="text"
                    placeholder={'Enter # of participants'}
                    inputProps={{ maxLength: 7 }}
                    onChange={(event) => {
                        if (
                            /^[1-9]\d*$/.test(event.target.value) ||
                            event.target.value == ''
                        ) {
                            let goal = event.target.value.substr(0, 10);
                            setInput('memberTarget', goal);
                        }
                        if (+event.target.value > 1000000) {
                            setError(
                                'Participants Goal should be less than 1,000,000',
                            );
                        }
                    }}
                />
            </FormInput>
            <div className="row">
                <div className="col col-6">
                    <DatePicker
                        title="Start Date*"
                        bootstrapIcon="icon-calendar-empty"
                        handleDateChange={(date) =>
                            setInput(
                                'startDate',
                                date
                                    ? new Date(
                                          date ? date : new Date(),
                                      ).setHours(0, 0, 0, 0)
                                    : null,
                            )
                        }
                        pickerProps={{
                            clearable: true,
                            value: challengeParams.startDate || null,
                            minDate: new Date(),
                        }}
                    />
                </div>
                <div className="col col-6">
                    <DatePicker
                        minDate={
                            challengeParams.startDate
                                ? challengeParams.startDate
                                : new Date()
                        }
                        title="End Date*"
                        bootstrapIcon="icon-calendar-empty"
                        handleDateChange={(date) =>
                            setInput(
                                'expiresAt',
                                date
                                    ? new Date(
                                          date ? date : new Date(),
                                      ).setHours(23, 59, 59, 99)
                                    : null,
                            )
                        }
                        pickerProps={{
                            disabled: challengeParams.startDate ? false : true,
                            clearable: true,
                            value: challengeParams.expiresAt || null,
                            minDate: challengeParams.startDate
                                ? new Date(
                                      new Date(challengeParams.startDate)
                                          .setHours(23, 59, 59, 99)
                                          .valueOf() + 10000,
                                  )
                                : new Date(
                                      new Date()
                                          .setHours(23, 59, 59, 99)
                                          .valueOf() + 10000,
                                  ),
                        }}
                    />
                </div>
            </div>
            {challengeType !== 'global' && (
                <ThemeInputSelector
                    title="Select Theme"
                    themes={CHALLENGE_THEME}
                    onSelect={(theme) => setInput('backgroundColor', theme)}
                    selectedTheme={
                        CHALLENGE_THEME[challengeParams.backgroundColor]
                    }
                    cardTitle={user.fullName || 'John Doe'}
                    cardImage={
                        user.profilePicture ||
                        'https://litterati-avatars-prod.s3-us-west-2.amazonaws.com/users/user-default/profile-picture-aqua.png'
                    }
                />
            )}
        </>
    );

    const onLoad = (ref) => {
        setRefSearchBox(ref);
    };

    const onPlacesChanged = () => {
        let selectedPlaces = refSearchBox.getPlaces()[0];
        setSelectedPlace([
            {
                id: selectedPlaces.place_id,
                locality: selectedPlaces.formatted_address,
                location: {
                    lat: selectedPlaces.geometry.location.lat(),
                    long: selectedPlaces.geometry.location.lng(),
                },
                circle: {
                    options: {
                        strokeColor: 'rgba(2, 122, 255)',
                        strokeOpacity: 0.8,
                        strokeWeight: 1,
                        fillColor: 'rgba(2, 122, 255)',
                        fillOpacity: 0.35,
                        clickable: false,
                        draggable: false,
                        editable: false,
                        visible: true,
                        zIndex: 1,
                    },
                },
            },
        ]);
    };
    const ifPlaces = selectedPlace.length
        ? selectedPlace[0]
        : {
              location: {
                  lat: null,
                  long: null,
                  radius: 1000,
              },
          };
    const CHALLENGE_TYPE_OBJECT_FILTERED = { ...CHALLENGE_TYPE_OBJECT };
    if (!permissions.includes('challenge_featured_create')) {
        delete CHALLENGE_TYPE_OBJECT_FILTERED.GLOBAL;
    }
    return (
        <div>
            <h1>Create a Challenge</h1>
            <div className="col">
                <div className="content-box">
                    <div className="row">
                        <Breadcrumb
                            navigation={breadcrumNavigation}
                            iconClass="icon-flag"
                            className="p-0 px-2"
                        />
                    </div>
                    <div className="row challenge-create py-4">
                        <div className="col col-6 create-challenge-form">
                            <DropdownFormInput
                                selected={
                                    CHALLENGE_TYPE_OBJECT_FILTERED[
                                        challengeType.toLocaleUpperCase()
                                    ].label
                                }
                                title="Type*"
                                bootstrapIcon="icon-flag"
                                menuData={Object.values(
                                    CHALLENGE_TYPE_OBJECT_FILTERED,
                                )}
                                onSelect={(type) => {
                                    setChallengeType(type);
                                }}
                            />
                            {showChallengeForm()}
                        </div>
                        <div className="col col-6">
                            {/* @ KHALID */}
                            <div className="customInput">
                                <h3 className="titleStyle2">Location</h3>

                                <div className="input-group">
                                    <GoogleMap
                                        id="createChallenge"
                                        options={{
                                            styles: MAP_STYLE_LIGHT,
                                            streetViewControl: false,
                                            mapTypeControl: false,
                                            fullscreenControl: false,
                                            zoomControl: false,
                                            disableDoubleClickZoom: true,
                                        }}
                                        zoom={13}
                                        center={{
                                            lat:
                                                ifPlaces.location.lat ||
                                                30.20533080721662,
                                            lng:
                                                ifPlaces.location.long ||
                                                -97.74973791571,
                                        }}
                                    >
                                        <div className="searchbox">
                                            <StandaloneSearchBox
                                                onLoad={onLoad}
                                                onPlacesChanged={
                                                    onPlacesChanged
                                                }
                                            >
                                                <FormInput
                                                    title=""
                                                    stylesIcon={{
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                    bootstrapIcon={Search}
                                                >
                                                    <TextField
                                                        disabled={worldwide}
                                                        placeholder="Select Location"
                                                    />
                                                </FormInput>
                                            </StandaloneSearchBox>
                                        </div>

                                        {selectedPlace.map((place) => (
                                            <Fragment key={place.id}>
                                                <Marker
                                                    icon={PointerMarker}
                                                    position={{
                                                        lat: parseFloat(
                                                            place.location.lat,
                                                        ),
                                                        lng: parseFloat(
                                                            place.location.long,
                                                        ),
                                                    }}
                                                />
                                                <Circle
                                                    center={{
                                                        lat: parseFloat(
                                                            place.location.lat,
                                                        ),
                                                        lng: parseFloat(
                                                            place.location.long,
                                                        ),
                                                    }}
                                                    options={{
                                                        ...place.circle.options,
                                                        radius,
                                                    }}
                                                />
                                            </Fragment>
                                        ))}

                                        <div className="radiusBlockMap">
                                            <div
                                                className="customInput"
                                                style={{
                                                    paddingBottom: 0,
                                                    width: '90%',
                                                    margin: '0 auto',
                                                }}
                                            >
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <h3 className="titleStyle2">
                                                        Radius
                                                    </h3>
                                                    {(challengeType ===
                                                        'local' &&
                                                        permissions.includes(
                                                            'local_challenge_location_skip',
                                                        )) ||
                                                    (challengeType ===
                                                        'connected' &&
                                                        permissions.includes(
                                                            'connected_challenge_location_skip',
                                                        )) ||
                                                    challengeType ===
                                                        'global' ? (
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={
                                                                        worldwide
                                                                    }
                                                                    onChange={() =>
                                                                        setWorldwide(
                                                                            !worldwide,
                                                                        )
                                                                    }
                                                                    name="checkedB"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="Worldwide"
                                                        />
                                                    ) : worldwide ? (
                                                        setWorldwide(false)
                                                    ) : null}
                                                </div>
                                                <div
                                                    className="input-group"
                                                    style={{ border: 0 }}
                                                >
                                                    <PrettoSlider
                                                        valueLabelDisplay="on"
                                                        aria-label="pretto slider"
                                                        disabled={worldwide}
                                                        min={10}
                                                        value={radius}
                                                        onChange={(e, radius) =>
                                                            setRadius(radius)
                                                        }
                                                        max={500000}
                                                        step={10}
                                                        valueLabelFormat={(
                                                            val,
                                                        ) => numFormatter(val)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </GoogleMap>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row my-3 position-relative">
                        {error && (
                            <small
                                className="position-absolute"
                                style={{
                                    top: '-25px',
                                    color: 'red',
                                    fontSize: '16px',
                                }}
                            >
                                {' '}
                                {error}{' '}
                            </small>
                        )}
                        <Button
                            variant="main mr-2"
                            disable={!allowSubmit}
                            value="Launch Challenge"
                            onClick={() => {
                                let challengeBody = transformChallengeForAPI({
                                    ...challengeParams,
                                    challengeType,
                                    circleRadius: radius,
                                    location: ifPlaces.location,
                                    locality: ifPlaces.locality,
                                    worldwide,
                                });
                                let allowSubmit = allowSubmission(
                                    challengeBody,
                                );
                                if (!allowSubmit.submit)
                                    setError(allowSubmit.error);
                                else if (
                                    challengeBody.expiresAt ===
                                    challengeBody.startDate
                                ) {
                                    setError(
                                        'End Date should be greater than Start Date',
                                    );
                                } else if (
                                    !challengeBody.worldwide &&
                                    !(
                                        typeof challengeBody.location.lat ==
                                            'number' &&
                                        typeof challengeBody.location.long ==
                                            'number'
                                    )
                                ) {
                                    setError(
                                        'Please select a location for your Challenge',
                                    );
                                } else if (
                                    challengeBody.website &&
                                    !isUrl(challengeBody.website)
                                ) {
                                    setError('Please enter a valid website.');
                                } else if (
                                    challengeBody.website &&
                                    challengeBody.website.length > 500
                                ) {
                                    setError(
                                        'Website link should be under 500 characters',
                                    );
                                } else if (
                                    challengeBody.memberTarget &&
                                    +challengeBody.memberTarget > 1000000
                                ) {
                                    setError(
                                        'Participant goal must be less than or equal to 1,000,000',
                                    );
                                } else
                                    !creatingChallenge &&
                                        onCreate(challengeBody);
                            }}
                        />
                        <Button
                            variant="secondary"
                            value="Cancel"
                            onClick={() => challengeModalOpen()}
                        />
                    </div>
                </div>
            </div>
            <div className="admin-delete-modal">
                <Modal
                    show={challengeModal}
                    onHide={challengeModalClose}
                    dialogClassName={'admin-delete-modal'}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    centered={true}
                    animation={true}
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="row title">Confirmation</div>
                            <div className="row">
                                Are you sure you want to cancel creating this
                                challenge?
                            </div>
                            <div className="row">
                                <button
                                    className={
                                        'btn btn-block delete-admin-button'
                                    }
                                    type={'button'}
                                    onClick={() => {
                                        setChallengeParams({
                                            ...defaultParams,
                                        });
                                        setParentChallenge(null);
                                        challengeModalClose();
                                        history.push(ROUTE_CHALLENGES);
                                    }}
                                >
                                    Yes
                                </button>
                            </div>

                            <div className="row mt-1">
                                <button
                                    className={
                                        'btn btn-block delete-button-cancel'
                                    }
                                    type={'button'}
                                    onClick={() => challengeModalClose()}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

CreateChallenge.propTypes = {
    // Function to be called when the Component/Screen loads
    onCreate: PropTypes.func,
    parentChallenges: PropTypes.func,
    user: PropTypes.object,

    clearCreatedChallenge: PropTypes.func,

    // Challenges to be displayed
    challenges: PropTypes.arrayOf(
        PropTypes.shape({
            ...challengePropTypes,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
        }),
    ),
    // boolean to represent the screen loading state\
    createdChallenge: PropTypes.object,
    createError: PropTypes.string,
    permissions: PropTypes.array,
    creatingChallenge: PropTypes.bool,
};

CreateChallenge.defaultProps = {
    challenges: [],
    onCreate: noop,
    clearCreatedChallenge: noop,
    parentChallenges: noop,
    createdChallenge: {},
    user: {},
    createError: null,
    creatingChallenge: false,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        user: getUser(state),
        challenges: getFeaturedChallenges(state),
        createdChallenge: getCreatedChallenge(state),
        createError: getCreateChallengeError(state),
        creatingChallenge: creatingChallengeState(state),
        permissions: getUserPermissionsKeys(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreate: (params) => dispatch(createChallengeRequested(params)),
        clearCreatedChallenge: () => dispatch(clearCreatedChallengeState()),
        parentChallenges: (search) =>
            dispatch(featuredChallengeRequested(search)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateChallenge);
